import React from 'react';
import { Button } from 'components/ui/button';
import { faHouseBuilding, faTrash } from '@fortawesome/pro-solid-svg-icons';
import EmptyState from '../empty_state';
import type { OwnedProperty } from 'bundles/connect/types';
import { setOffMarketPropertyId } from 'bundles/connect/components/store/actions/off_market_property';
import { connect } from 'react-redux';

type Props = {
  ownedProperties: OwnedProperty[];
  onDeleteOwnedProperty: (property: OwnedProperty) => void;
  setOffMarketPropertyId: (id: string) => void;
}

function OwnedPropertiesList({ ownedProperties, onDeleteOwnedProperty, setOffMarketPropertyId }: Props) {

  if (ownedProperties.length === 0) {
    return (
      <EmptyState
        icon={faHouseBuilding}
        text="This contact has no properties"
      />
    );
  }

  return (
    <>
      {ownedProperties.map(ownedProperty => (
        <div className="d-flex border-bottom align-items-center justify-content-between p-2" key={ownedProperty.propertyId}>
          <Button
            className="text-truncate fw-bolder"
            variant="ghost"
            onClick={() => setOffMarketPropertyId(ownedProperty.propertyId)}
          >
            {ownedProperty.address}, {ownedProperty.city}, {ownedProperty.state}
          </Button>
          <Button
            className="text-danger"
            icon={faTrash}
            variant="ghost"
            onClick={() => onDeleteOwnedProperty(ownedProperty)}
          />
        </div>
      ))}
    </>
  );
}

export default connect(undefined, { setOffMarketPropertyId })(OwnedPropertiesList);
